import IntegrationCard from "../../IntegrationCard/IntegrationCard";
import DoubleLogo from "./double-logo.png";
import { useOverlayContext } from 'seagull';
import ConnectKeeperModal from "../ConnectKeeperModal/ConnectKeeperModal";
import { integrationModel } from "../../../../models";
import { useHistory } from 'react-router';
import { routes } from "../../../../constants";
import { getPMDetails } from "../../../PracticeManagement/pm.utils";
import { PracticeManagement } from "../../../../types/api.model";
import { jsx as _jsx } from "react/jsx-runtime";
export default function KeeperCard(_ref) {
  let {
    integration
  } = _ref;
  const overlayContext = useOverlayContext();
  const history = useHistory();
  const keeperDetails = getPMDetails(PracticeManagement.Keeper);
  const openIntegrateWithKeeperModal = () => {
    overlayContext.showModal({
      closeOnEscapeKey: true,
      closeOnClickOutside: true,
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/_jsx(ConnectKeeperModal, {
          dismissModal: dismissModal
        });
      }
    });
  };
  const handleClick = () => {
    if (integrationModel.isLinked(integration)) {
      history.push(routes.keeperSetup);
    } else {
      openIntegrateWithKeeperModal();
    }
  };
  return /*#__PURE__*/_jsx(IntegrationCard, {
    "data-testid": "keeper-card",
    icon: /*#__PURE__*/_jsx(IntegrationCard.LogoImg, {
      padding: "6px 0",
      alt: "".concat(keeperDetails.name, " logo"),
      src: DoubleLogo
    }),
    title: keeperDetails.name,
    subTitle: "Connect your account for efficient workflows between your team and your clients",
    mainAction: /*#__PURE__*/_jsx(IntegrationCard.MainActionButton, {
      onClick: handleClick,
      "data-testid": "keeper-card-connect",
      children: integrationModel.isLinked(integration) ? 'Manage connection' : 'Connect'
    })
  });
}